    import './InfoEdit.scss';
    import React, { useState } from 'react';
    import Button from '@mui/material/Button';
    import { useSelector, useDispatch } from 'react-redux';
    import { setUserInfo } from '../../reduxToolkit/redux';
    import fnc from '../mymod/commFunction';

    function InfoEdit() {
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.appReducer.userInfo);

    const [stName, setStName] = useState(userInfo.userName || '');
    const [hp, setHp] = useState(userInfo.hp || '');
    const [email, setEmail] = useState(userInfo.email || '');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!stName.trim()) {
        alert('이름을 입력해주세요.');
        return;
        }

        fnc.sendAxios('/accountRoutes/updateUserInfo', {
        id: userInfo.userId,
        stName: stName.trim(),
        hp: hp.trim(),
        email: email.trim(),
        }, (res) => {
        if (res.error) {
            alert(res.message || '수정에 실패했습니다.');
            return;
        }
        dispatch(setUserInfo({ ...userInfo, userName: stName.trim(), hp: hp.trim(), email: email.trim() }));
        alert('정보가 수정되었습니다.');
        });
    };

    return (
        <div className='InfoEdit'>
        <form onSubmit={handleSubmit}>
            <p className='section-title'>정보 수정</p>

            <div>
            <label>*아이디</label>
            <input type='text' value={userInfo.userId || ''} disabled className='disabled' />
            </div>

            <div>
            <label>*이름</label>
            <input
                type='text'
                value={stName}
                onChange={(e) => setStName(e.target.value)}
                placeholder='이름을 입력하세요'
            />
            </div>

            <div>
            <label>*휴대폰</label>
            <input
                type='text'
                value={hp}
                onChange={(e) => setHp(e.target.value)}
                placeholder='01012345678'
                maxLength={11}
            />
            </div>

            <div>
            <label>*이메일</label>
            <input
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder='example@email.com'
            />
            </div>

            <Button variant='contained' className='btn-submit' type='submit'>
            수정 완료
            </Button>
        </form>
        </div>
    );
    }

    export default InfoEdit;
